<app-dialog [dialogWithInput]="dialog">
    <app-card>
        <div class="row">
            <app-form-field size="12" sizeXl="12" sizeLg="12" label="Fichier" [required]="true">
                <app-file-upload [maxFileCount]="dialog.input.nbMaxFiles" #fileUpload [allowedFileExtensions]="dialog.input.allowedFileExtensions ? dialog.input.allowedFileExtensions : []" [maxSizeInMo]="dialog.input.maxSizeInMo" (filedAddedEvent)="fileAdded($event)"></app-file-upload>
            </app-form-field>
        </div>
    </app-card>
    <app-button label="Valider" [disabled]="fileItems?.length === 0" fill="solid" dialog-actions (clickEvent)="close()"></app-button>
</app-dialog>
